import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Default request timeout (60 seconds)
window.axios.defaults.timeout = 60000;

// Configure CSRF token for axios requests
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Ensure credentials are sent with requests (important for session-based auth)
window.axios.defaults.withCredentials = true;

// Function to refresh CSRF token without full page reload
let isRefreshingCsrf = false;
let csrfRefreshPromise = null;

window.refreshCsrfToken = async function() {
    // If a refresh is already in progress, wait for it
    if (isRefreshingCsrf && csrfRefreshPromise) {
        return csrfRefreshPromise;
    }

    isRefreshingCsrf = true;
    csrfRefreshPromise = (async () => {
        try {
            const response = await fetch('/api/csrf-token', {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                }
            });

            if (response.ok) {
                const data = await response.json();
                const csrfMeta = document.head.querySelector('meta[name="csrf-token"]');
                if (csrfMeta && data.csrf_token) {
                    csrfMeta.content = data.csrf_token;
                    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.csrf_token;
                    return true;
                }
            }
        } catch (error) {
            console.error('Failed to refresh CSRF token:', error);
        }
        return false;
    })();

    try {
        return await csrfRefreshPromise;
    } finally {
        isRefreshingCsrf = false;
        csrfRefreshPromise = null;
    }
};

// Global Axios interceptor for handling 419 CSRF token expiration
window.axios.interceptors.response.use(
    response => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 419 && !originalRequest._csrfRetried) {
            originalRequest._csrfRetried = true;

            const refreshed = await window.refreshCsrfToken();

            if (refreshed) {
                // Update the failed request's header with the new token
                originalRequest.headers['X-CSRF-TOKEN'] =
                    window.axios.defaults.headers.common['X-CSRF-TOKEN'];
                return window.axios(originalRequest);
            }

            // Token refresh failed — session is truly dead
            if (typeof window.showSessionExpiredModal === 'function') {
                window.showSessionExpiredModal();
            } else {
                window.location.reload();
            }

            return new Promise(() => {}); // Halt the promise chain
        }

        return Promise.reject(error);
    }
);

// Session keep-alive heartbeat
// Pings /api/csrf-token every 15 minutes while the tab is visible,
// keeping the server session alive and the CSRF token fresh.
(function initSessionHeartbeat() {
    const HEARTBEAT_INTERVAL = 15 * 60 * 1000; // 15 minutes
    let heartbeatTimer = null;

    function startHeartbeat() {
        if (heartbeatTimer) return;
        heartbeatTimer = setInterval(() => {
            window.refreshCsrfToken();
        }, HEARTBEAT_INTERVAL);
    }

    function stopHeartbeat() {
        if (heartbeatTimer) {
            clearInterval(heartbeatTimer);
            heartbeatTimer = null;
        }
    }

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            // Refresh immediately when returning to the tab, then restart interval
            window.refreshCsrfToken();
            startHeartbeat();
        } else {
            stopHeartbeat();
        }
    });

    // Start on load if tab is visible
    if (document.visibilityState === 'visible') {
        startHeartbeat();
    }
})();
